export const environment = {
  production: true,
  connection: {
    name: 'Holz Rentsch Softline',
    host: location.protocol + '//' + location.hostname,
    port: Number(location.port) ?? 443,
    basePath: '/api',
  },
  androidUpdateRepository: '',
};
